export default "__VITE_ASSET__89bd6bdd__"